import { useNavigate } from 'react-router-dom';

import { Button, Card, StatusView } from '@/components/ui';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <Card>
      <StatusView
        icon="search"
        title="Page not found"
        message="That address does not match anything in ELA Lab."
        action={
          <Button variant="primary" icon="arrow-left" onClick={() => navigate('/')}>
            Back to overview
          </Button>
        }
      />
    </Card>
  );
}
